import React, { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, useLocation, Outlet, json } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { Nav, Navbar, Container } from 'react-bootstrap';
import { useSpring, animated } from '@react-spring/web'
import toast, { Toaster } from 'react-hot-toast';
import ReactGA from "react-ga4";

import RouteChangeTracker from "./RouteChangeTracker.js";
import Main from './Main.js';
import Create from './Create.js';
import Lib from './Lib.js';
import Mypage from './Mypage.js';
import Game from './Game.js';
import Play from './Play.js';
import Admin from './Admin.js';
import Cresoul from './Cresoul.js';

import './App.css';
import './Bs.css';

import ImgLogo from './img/Logo.webp';
import ImgTitle from './img/Title_Black.png';


function App() {

  const store = useSelector((state) => state);
  const navigate = useNavigate();
  const location = useLocation();

  RouteChangeTracker();
  
  
  return (
    //<div className="App d-flex flex-column" style={{ height: '100vh' }}>
    <div className="text-center">
      {/* <Navbar className='fixed-top py-0' bg="primary" variant="dark">
        <Container className='d-flex'>
          <Navbar.Brand className='d-flex align-items-center' onClick={() => { navigate('/') }}>
            <img className='' src={ImgLogo} style={{ height: '45px' }} alt='밸런스게임으로 보는 궁합 - 밸궁 앰블럼 로고'></img>
            <span className='mx-1'></span>
            <img className='' src={ImgTitle} style={{ height: '40px' }} alt='밸런스게임으로 보는 궁합 - 밸궁 텍스트 로고'></img>
          </Navbar.Brand>
          <Nav className='d-flex me-auto'>
            <Nav.Link onClick={() => { navigate('/') }}>홈</Nav.Link>
            <Nav.Link onClick={() => { navigate('/create') }}>만들기</Nav.Link>
            <Nav.Link onClick={() => { navigate('/mypage') }}>MY</Nav.Link>
          </Nav>
          <Nav className='d-flex justify-content-end'>
            <Nav.Link className='p-0' onClick={() => {
              navigate('/cresoul');
            }}><i class="fi-rr-menu-dots va-m"></i></Nav.Link>
          </Nav>

        </Container>
      </Navbar> */}

      <Toaster />


      <div className='width-sm margin-auto'>
        <div className='m-3 py-5'>
          <Routes>

            <Route path='/' element={<Main />} />

            <Route path='/create' element={<Create />} />

            <Route path='/lib' element={<Lib />} />
            <Route path='/lib/:pw' element={<Lib />} />

            <Route path='/mypage' element={<Mypage />} />

            <Route path='/game/:uid' element={<Game />} />

            <Route path='/game/:uid/play' element={<Play />} />

            <Route path='/admin/:pw' element={<Admin />} />

            <Route path='/cresoul' element={<Cresoul />} />

            <Route path='/*' element={
              <>
                잘못된 주소에요.
              </>
            } />

          </Routes>

        </div>
      </div>
    </div>

  )
}


export default App;
